import { render, staticRenderFns } from "./CustomerMergeModal.vue?vue&type=template&id=6e762564&"
import script from "./CustomerMergeModal.vue?vue&type=script&lang=js&"
export * from "./CustomerMergeModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMergeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports